export class Competition {
	id: string;
	horse_show_id: string;
	section_id: string;
	number: number;
	name: string;
	section_number: number;
	location_number: number;
	championship_group_number: number;
	prize_group_number: number;
	entry_fee: number;
	level: string;
	rules: string;
	date: Date;
	time: string;
	time_of_day: string;
	count_points_towards_championship: boolean;
	addback_group_number: number;
	sponsor: string;
	cancelled: boolean;
	number_of_competitors: number;
	schedule_position: number;
	flat: boolean;
	usef_section_code: string;
	ec_section_code: string;
	time_per_round: number;
	note: string;
	display_order_online: boolean;
	award_only: boolean;
	combined_with_id: string;
	combined_with_number: number;
	type: string;
	est_start_time: string;
	act_start_time: string;
	est_end_time: string;
	act_end_time: string;
	number_of_placed_competitons: number;
	unit: string;
	pay_entry_fee_online: boolean;
	restrict_entry: boolean;
	restrict_scratch: boolean;
	collect_scratch_fee: boolean;
	custom_scratch_fee: boolean;
	entry_form_alias: string;
	hide_on_entry: boolean;

	//View only
	selected: boolean = false;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}


}